import AuthenticatedRoute from 'eflex/util/authenticated-route';
import { service } from '@ember/service';

export default class ContainPartsScrappedRoute extends AuthenticatedRoute {
  @service store;

  queryParams = {
    serialNumber: {
      refreshModel: false,
    },
  };

  async model(params) {
    this.store.unloadAll('jem-containment');
    params.scrap = true;
    await this.store.query('jem-containment', params);
  }
}
